import React, { FC, useCallback } from "react";
import styled from "styled-components/macro";
import Module from "shared/lib/interfaces/Module";
import ModuleSection from "shared/lib/interfaces/ModuleSection";
import ModuleActivityKind from "shared/lib/enums/ModuleActivityKind";
import { BearIcons } from "../../../../common/components/BearIcon";
import { SlidePageProgress, SlidePageProps } from "../../SlidePage";
import VideoActivity from "../../VideoActivity";
import { useVideoActivity } from "../../../contexts/ModuleActivityContext";
import ActivitySlidePage from "../../ActivitySlidePage";
import VideoId from "shared/lib/enums/VideoId";

const activityKind =
  ModuleActivityKind.COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO;

interface Props {
  module: Pick<Module, "icon" | "name" | "sections">;
  section: Pick<ModuleSection, "name" | "id">;
  progress: SlidePageProgress;
  onNext: SlidePageProps["onNext"];
  onBack: SlidePageProps["onBack"];
  isReview?: boolean;
}

const ManagingStressContent3Slide: FC<Props> = (props) => {
  const { module, section, onNext, isReview, ...rest } = props;
  const [onPlayStart, onPlayEnd, videoCompleted] = useVideoActivity(
    activityKind,
    VideoId.COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO
  );

  const handleSlideNext = useCallback(() => {
    onPlayEnd(true);
    onNext();
  }, [onPlayEnd, onNext]);

  return (
    <ActivitySlidePage
      {...rest}
      hideNextButton={!videoCompleted && !isReview}
      isReview={isReview}
      activityKind={activityKind}
      title={module.name}
      onNext={handleSlideNext}
      bearIcon={BearIcons.GIRL_THUMBS_UP}
    >
      <section>
        <h3>MANAGING STRESS</h3>
        <p>
          Another strategy that can help you relax is deep breathing. Try this
          simple breathing exercise to take a short break from your problems —it
          works quickly, and you can do it anywhere.
        </p>
      </section>
      <VideoActivity
        onEnded={onPlayEnd}
        onStarted={onPlayStart}
        videoId={VideoId.COPING_WITH_STRESS_BREATHING_STRATEGY_VIDEO}
      />
    </ActivitySlidePage>
  );
};

export default styled(ManagingStressContent3Slide)``;
